import { render, staticRenderFns } from "./PolicyApplications.vue?vue&type=template&id=93a815b4&scoped=true&"
import script from "./PolicyApplications.vue?vue&type=script&lang=ts&"
export * from "./PolicyApplications.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyApplications.vue?vue&type=style&index=0&id=93a815b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a815b4",
  null
  
)

export default component.exports